import {Component, DestroyRef, inject, model, OnInit, signal} from '@angular/core';
import {ConfigService, NotificationService, TjKeycloakService} from '../../../../core/services';
import {environment} from '../../../../../environments/environment';
import {Area} from '../../../../api/model/Area.model';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ApiService} from '../../../../api/service/api.service';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'tj-area-surcharge-configuration',
  templateUrl: './area-surcharge-configurations.component.html',
  styleUrls: ['./area-surcharge-configurations.component.scss'],
})
export class AreaSurchargeConfigurationsComponent implements OnInit {
  protected readonly env = environment;

  private api = inject(ApiService);
  private configService = inject(ConfigService);
  private notificationService = inject(NotificationService);
  private destroy$ = inject(DestroyRef);
  private keycloakService = inject(TjKeycloakService);
  private fb = inject(FormBuilder);

  protected areas = signal<Area[]>([]);

  editDialog = model<boolean>(false);
  updatedArea = model<Area | null>(null);

  surchargeForm = this.fb.group({
    surcharge: [0, [Validators.required]],
  });


  constructor() {
  }

  ngOnInit() {
    this.configService.areas$
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe({
        next: areas => {
          this.areas.set(areas);
        }
      });
  }

  updateSurcharge() {
    if (this.isSurchargeEditRestricted()) {
      this.notificationService.error('You do not have the required permission');
      return;
    }
    const savedTagIndex = this.areas().findIndex(area => area.id === this.updatedArea().id);
    if (savedTagIndex !== -1) {
      const newSurcharge = this.surchargeForm.value.surcharge;
      this.api.area
        .updateSurcharge(this.updatedArea().id, newSurcharge)
        .pipe(takeUntilDestroyed(this.destroy$))
        .subscribe({
          next: () => {
            this.updatedArea.set({
              ...this.updatedArea(),
              surcharge: newSurcharge,
            });
            const updatedAreas = [...this.areas()];
            updatedAreas[savedTagIndex] = this.updatedArea();
            this.areas.set(updatedAreas);
            this.notificationService.success('Successfully updated');
          },
          error: err => {
            this.notificationService.error(err);
          }
        });
    }
  }

  isSurchargeEditRestricted() {
    return !this.keycloakService.hasRole('AREA_APP_SURCHARGE_EDIT');
  }

  onEditSurcharge(area: Area) {
    this.updatedArea.set(area);
    this.surchargeForm.patchValue({surcharge: area.surcharge});
    this.editDialog.set(true);
  }

  onHideEditDialog() {
    this.editDialog.set(false);
  }

  onSaveSurcharge() {
    if (this.surchargeForm.valid) {
      this.updateSurcharge();
      this.editDialog.set(false);
    }
  }
}
